import { render } from "./AppGuide.vue?vue&type=template&id=256c2646"
import script from "./AppGuide.vue?vue&type=script&lang=js"
export * from "./AppGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__